import { LazyTabLabECharts } from '@/components/ui/charts/lazy-tab-lab-echarts';
import type { EChartsOption } from 'echarts';
import { BoxPlotStats } from '../../../lib/stats/types';

export interface BoxPlotProps {
  data: BoxPlotStats;
  title?: string;
  xAxisLabel?: string;
  yAxisLabel?: string;
  height?: number;
  width?: number;
  className?: string;
  orientation?: 'horizontal' | 'vertical';
  showOutliers?: boolean;
}

export function BoxPlot({
  data,
  title = '',
  xAxisLabel = '',
  yAxisLabel = 'Value',
  height = 300,
  width,
  className = '',
  orientation = 'vertical',
  showOutliers = false
}: BoxPlotProps) {
  const boxData = [[data.min, data.q1, data.median, data.q3, data.max]];

  const option: EChartsOption = {
    title: {
      text: title,
      left: 'center',
      top: 10,
      textStyle: {
        fontSize: 16,
        fontWeight: 'bold'
      }
    },
    tooltip: {
      trigger: 'item',
      axisPointer: {
        type: 'shadow'
      },
      formatter: (params: any) => {
        const data = params.data;
        return `
          Min: ${data[0]}<br/>
          Q1: ${data[1]}<br/>
          Median: ${data[2]}<br/>
          Q3: ${data[3]}<br/>
          Max: ${data[4]}
        `;
      }
    },
    grid: {
      left: '10%',
      right: '10%',
      bottom: '15%',
      top: '15%'
    },
    xAxis: orientation === 'horizontal' ? {
      type: 'value',
      name: xAxisLabel,
      nameLocation: 'middle',
      nameGap: 30,
      scale: true
    } : {
      type: 'category',
      name: xAxisLabel,
      nameLocation: 'middle',
      nameGap: 30,
      data: ['']
    },
    yAxis: orientation === 'horizontal' ? {
      type: 'category',
      name: yAxisLabel,
      nameLocation: 'middle',
      nameGap: 40,
      data: ['']
    } : {
      type: 'value',
      name: yAxisLabel,
      nameLocation: 'middle',
      nameGap: 40,
      scale: true
    },
    series: [
      {
        name: 'boxplot',
        type: 'boxplot',
        data: boxData,
        itemStyle: {
          color: '#8884d8',
          borderColor: '#4d4dff'
        },
        emphasis: {
          itemStyle: {
            borderColor: '#4d4dff',
            shadowBlur: 10,
            shadowColor: 'rgba(0,0,0,0.3)'
          }
        },
        tooltip: {
          formatter: (param: any) => {
            return [
              'Five Number Summary',
              `Maximum: ${param.data[5]}`,
              `Upper Quartile: ${param.data[4]}`,
              `Median: ${param.data[3]}`,
              `Lower Quartile: ${param.data[2]}`,
              `Minimum: ${param.data[1]}`
            ].join('<br/>');
          }
        }
      }
    ]
  };

  return (
    <div style={{ height, width }} className={className}>
      <LazyTabLabECharts option={option} themeName="gentle-photon-stream" />
    </div>
  );
} 